export enum EUserGender {
  Unknown = 0,
  MALE = 1,
  FEMALE = 2,
  OTHER = 3,
}
